/**
 * @generated SignedSource<<78ac25809e476865617602bbc1b881b8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersCheckArticleRenderTypeArticle$data = {
  readonly " $fragmentSpreads": FragmentRefs<"helpersCheckCanShowInPlusPlatformContent" | "helpersCheckIsPlusArticle" | "helpersCheckIsPostMagazineArticle" | "helpersCheckIsStyleArticle" | "helpersCheckIsVideoContent" | "helpersGetArticleTypeArticle">;
  readonly " $fragmentType": "helpersCheckArticleRenderTypeArticle";
};
export type helpersCheckArticleRenderTypeArticle$key = {
  readonly " $data"?: helpersCheckArticleRenderTypeArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersCheckArticleRenderTypeArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersCheckArticleRenderTypeArticle"
};

(node as any).hash = "9b9ceee3d149fd80d1434df58b62d7e9";

export default node;
